import { Component, type ReactNode } from 'react'
import { ErrorAPI } from '../../api/client'

interface Props {
  children: ReactNode
  playerId?: string
}

interface State {
  hasError: boolean
  message: string
}

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, message: '' }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, message: error?.message ?? 'Unknown error' }
  }

  componentDidCatch(error: Error, info: { componentStack: string }) {
    ErrorAPI.report(
      error.message,
      (error.stack ?? '') + '\n\nComponent stack:\n' + info.componentStack,
      this.props.playerId
    )
  }

  render() {
    if (!this.state.hasError) return this.props.children

    return (
      <div className="min-h-screen bg-ab-deep flex flex-col items-center justify-center px-6 text-center gap-6">
        <div className="text-5xl">⚡</div>
        <div>
          <h1 className="font-display font-black text-2xl text-ab-text mb-2">Something broke</h1>
          <p className="text-body text-sm opacity-70 mb-4">
            The error has been reported. Try reloading.
          </p>
          <p className="text-label text-xs opacity-40 font-mono">{this.state.message}</p>
        </div>
        <button
          onClick={() => window.location.reload()}
          className="btn-primary px-6 py-3"
        >
          Reload App
        </button>
      </div>
    )
  }
}
